import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { isValidArray } from "../../Layout/Common/common";
import { bigImageScript } from "./scripts";
import { useProductOverlay } from "./productOverlay/productOverlayContext";

export const BigImageViewer = ({ params, indexs }) => {
  const [imageList, setImageList] = useState(null);
  const modalRef = useRef(null);
  const portalTarget = useProductOverlay()?.portalTarget;
  useEffect(() => {
    setTimeout(() => {
      bigImageScript(modalRef.current ?? document);
    }, 2000);
    setImageList(params);
  }, [params, indexs]);

  const modal = imageList && (
    <div
      ref={modalRef}
      className="modal fade"
      id="productGalleryPopup"
      tabIndex={-1}
      aria-labelledby=""
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl modal-dialog-centered">
        <div className="modal-content">
          <p className="order-status-close" data-bs-dismiss="modal">
            <i className="fa-regular fa-circle-xmark" />
          </p>
          <div className="container-fluid modal-body">
            <div className="row popup-image-container">
              {/* Small Images on the Left */}
              <div className="col-md-2 col-lg-2 order-2 order-md-1 popup-small-images mt-3 mt-lg-0">
                <div className="popup-small-slider">
                  <span className="popup-thumb-prev">
                    <i className="fa-solid fa-chevron-up" />
                  </span>
                  <div className="popup-thumb-container">
                    {isValidArray(imageList) &&
                      imageList.map((item, index) => (
                        <img
                          key={index}
                          className={"popupsmallImage " + (index == indexs ? "active" : "")}
                          src={item}
                          alt={"Small Image " + index}
                          data-big={item}
                        />
                      ))}
                  </div>
                  <span className="popup-thumb-next">
                    <i className="fa-solid fa-chevron-down" />
                  </span>
                </div>
              </div>
              {/* Big Image / Video Container */}
              <div className="col-md-10 col-lg-10 order-1 order-md-2 popup-big-image position-relative">
                <div className="popupBigImage">
                  <span className="popup-big-prev">
                    <i className="fa-solid fa-chevron-left" />
                  </span>
                  <div id="popupContent">
                    <img id="popupbigImage" src={imageList[indexs]} alt="Big Image" />
                    <div id="zoomLens" />
                  </div>
                  <span className="popup-big-next">
                    <i className="fa-solid fa-chevron-right" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  if (!modal) return null;
  return portalTarget ? createPortal(modal, portalTarget) : modal;
};
